import React from "react";
import { Animated, View } from "react-native";
import Text from "app/components/Text";
import toastActions from "app/utils/toastActions";
import { StyleContext } from "app/contexts/Style";
import ENV from "app/utils/ENV";

export default class Toast extends React.Component {
  static contextType = StyleContext;

  constructor(props) {
    super(props);
    this.state = {
      message: null,
      anim: new Animated.Value(0),
    };
    this._timer = null;
    this._animation = null;
  }

  componentDidMount() {
    toastActions.register(this.show);
  }

  componentWillUnmount() {
    toastActions.register(null);
    clearTimeout(this._timer);
    this._animation && this._animation.stop();
  }

  show = (message) => {
    clearTimeout(this._timer);
    this._animation && this._animation.stop();
    this.state.anim.setValue(0);

    this.setState({ message }, () => {
      this._animation = Animated.sequence([
        Animated.timing(this.state.anim, {
          toValue: 1,
          duration: 180,
          useNativeDriver: true,
        }),
        Animated.delay(2600),
        Animated.timing(this.state.anim, {
          toValue: 0,
          duration: 400,
          useNativeDriver: true,
        }),
      ]);
      this._animation.start(() => this.setState({ message: null }));
    });
  };

  render() {
    const { message, anim } = this.state;
    if (!message) return null;

    const translateY = anim.interpolate({
      inputRange: [0, 1],
      outputRange: [12, 0],
    });

    return (
      <Animated.View
        pointerEvents="none"
        style={{
          position: ENV.WEB ? "fixed" : "absolute",
          bottom: 24,
          left: 0,
          right: 0,
          alignItems: "center",
          zIndex: 9999,
          opacity: anim,
          transform: [{ translateY }],
        }}
      >
        <View
          style={{
            backgroundColor: this.context.colors.foreground,
            borderRadius: 10,
            paddingHorizontal: 16,
            paddingVertical: 9,
            maxWidth: 380,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.18,
            shadowRadius: 6,
            elevation: 8,
          }}
        >
          <Text
            style={{
              color: this.context.colors.empty,
              fontSize: this.context.sizes.default,
              textAlign: "center",
            }}
          >
            {message}
          </Text>
        </View>
      </Animated.View>
    );
  }
}
